const userMenu = {
  personalAccount: "Personal Account",
  businessAccount: "Business Account",
  profile: "My Profile",
  settings: "Settings",
  signOut: "Sign Out",
  switchAccount: "Switch Account",
  online: "Online",
  role: "Role",
  admin: "Admin",
  member: "Member",
  viewer: "Viewer",
} as const;
export default userMenu;
